import React from 'react';
import { 
  Send, 
  Twitter, 
  Instagram, 
  Linkedin, 
  Youtube, 
  Mail, 
  MapPin, 
  Phone 
} from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-slate-100 font-sans text-slate-900">
      {/* --- NEWSLETTER SECTION --- */}
     

      {/* --- MAIN FOOTER LINKS --- */}
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Brand Column */}
        <div className="space-y-6">
          <h2 className="text-2xl font-black tracking-tighter text-[#0a1d2e]">
            MBOGI<span className="text-[#c07d3e]">CAPITAL</span>
          </h2>
          <p className="text-slate-500 leading-relaxed">
            The first crowd-investing platform dedicated to empowering African filmmakers through transparent blockchain technology.
          </p>
          <div className="flex gap-4">
            {[Twitter, Instagram, Linkedin, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-10 h-10 rounded-xl bg-slate-50 flex items-center justify-center text-slate-400 hover:bg-[#c07d3e] hover:text-white transition-all shadow-sm">
                <Icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
  {/* Platform Links */}
  <div>
    <h4 className="font-bold text-[#0a1d2e] mb-6">Platform</h4>
    <ul className="space-y-4 text-slate-500 text-sm">
      <li>
        <a href="/how-it-works" className="hover:text-[#c07d3e] transition-colors">How It Works</a>
      </li>
      <li>
        <a href="/who-its-for" className="hover:text-[#c07d3e] transition-colors">Who It's For</a>
      </li>
      <li>
        <a href="/investors" className="hover:text-[#c07d3e] transition-colors">Investors</a>
      </li>
      <li>
        <a href="/waitlist" className="hover:text-[#c07d3e] transition-colors font-semibold">Join Waitlist</a>
      </li>
    </ul>
  </div>

  {/* Legal Links */}
  <div>
    <h4 className="font-bold text-[#0a1d2e] mb-6">Legal</h4>
    <ul className="space-y-4 text-slate-500 text-sm">
      <li>
        <a href="/privacy-policy" className="hover:text-[#c07d3e] transition-colors">Privacy Policy</a>
      </li>
      <li>
        <a href="/terms" className="hover:text-[#c07d3e] transition-colors">Terms & Conditions</a>
      </li>
      <li>
        <a href="/governance" className="hover:text-[#c07d3e] transition-colors">Governance Protocol</a>
      </li>
    </ul>
  </div>

  {/* Contact/Social Placeholder */}
  <div>
    <h4 className="font-bold text-[#0a1d2e] mb-6">Connect</h4>
    <ul className="space-y-4 text-slate-500 text-sm">
      <li>
        <a href="https://twitter.com/mbogicapital" target="_blank" rel="noreferrer" className="hover:text-[#c07d3e] transition-colors">Twitter / X</a>
      </li>
      <li>
        <a href="mailto:hello@mbogicapital.com" className="hover:text-[#c07d3e] transition-colors">Email Support</a>
      </li>
    </ul>
  </div>
</div>

        {/* Support */}
        <div>
          <h4 className="font-bold text-lg mb-6">Resources</h4>
          <ul className="space-y-4 text-slate-500">
            {['Whitepaper', 'Community Hub', 'Help Center', 'API Docs', 'Risk Disclosure'].map((item) => (
              <li key={item}><a href="#" className="hover:text-[#c07d3e] transition-colors">{item}</a></li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="font-bold text-lg mb-6">Get in Touch</h4>
          <ul className="space-y-4 text-slate-500">
            <li className="flex gap-3">
              <MapPin className="w-5 h-5 text-[#c07d3e] flex-shrink-0" />
              <span>Nairobi, Kenya — Global Headquarters</span>
            </li>
            <li className="flex gap-3">
              <Mail className="w-5 h-5 text-[#c07d3e] flex-shrink-0" />
              <span>hello@mbogicapital.com</span>
            </li>
            <li className="flex gap-3">
              <Phone className="w-5 h-5 text-[#c07d3e] flex-shrink-0" />
              <span>+254 700 000 000</span>
            </li>
          </ul>
        </div>
      </div>

      {/* --- BOTTOM BAR --- */}
      <div className="border-t border-slate-100 bg-slate-50/50">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
          <p>© {currentYear} MbogiCapital. Built with passion for African Cinema.</p>
          <div className="flex gap-8">
            <a href="/privacy-policy" className="hover:text-slate-900 transition-colors">Privacy Policy</a>
            <a href="/terms-and-conditions" className="hover:text-slate-900 transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-slate-900 transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}